export default __webpack_public_path__ + "static/version-lifecycle-5ed076c903a01669d5ac99a352a73114.png";